var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudiesJamaNatwork123X25(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 25,
    viewBox: "0 0 123 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17892_561023)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2104 6.46484L8.05518 19.8982H10.4823L11.7439 16.3437H17.1067L18.3674 19.8982H20.8902L15.7146 6.46484H13.2104ZM14.4149 8.77906H14.4715L16.4852 14.5549H12.384L14.4149 8.77906Z",
    fill: "#272724"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.392 6.46484V19.8982H110.577V16.2099L112.496 14.6111L116.335 19.8982H117.823L113.4 13.7838L117.539 10.1898H115.958L110.577 14.894V6.46484H109.392Z",
    fill: "#272724"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.43121 6.46484H6.07937V15.7041C6.07937 17.3782 5.72169 18.2998 4.19715 18.2998C2.76644 18.2998 2.35162 17.4144 2.35162 15.8908V15.195H0.000244141V15.9103C0.000244141 18.3755 1.16757 20.2196 4.00763 20.2196C7.86729 20.2196 8.43121 17.9054 8.43121 15.5698V6.46484Z",
    fill: "#272724"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.763 12.4648H104.726V10.1896H103.633V19.898H104.818V14.7252C104.818 12.6911 106.287 11.1507 108.431 11.2436V10.0559C106.682 9.98293 105.365 10.886 104.763 12.4648Z",
    fill: "#272724"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3628 10.9027C72.2613 10.9027 73.3919 12.5791 73.4491 14.3675H67.1623C67.3723 12.5982 68.4063 10.9027 70.3628 10.9027ZM70.3628 9.90771C67.2757 9.90771 65.9783 12.4844 65.9783 15.0439C65.9783 17.8105 67.2757 20.1805 70.3628 20.1805C72.829 20.1805 74.0864 18.9031 74.5964 16.6985H73.4105C73.0343 18.1877 72.0936 19.1855 70.3628 19.1855C68.1058 19.1855 67.1623 17.0952 67.1623 15.3649H74.6327C74.7274 12.6349 73.4691 9.90771 70.3628 9.90771Z",
    fill: "#272724"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5712 7.27246H76.3834V10.1896H74.6917V11.1874H76.3834V17.83C76.3653 19.4846 76.9116 20.0127 78.4909 20.0127C78.8509 20.0127 79.1877 19.976 79.5445 19.976V18.9592C79.2072 18.9955 78.8677 19.0145 78.5295 19.0145C77.6827 18.9592 77.5712 18.5068 77.5712 17.7348V11.1874H79.5445V10.1896H77.5712V7.27246Z",
    fill: "#272724"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.1948 19.1855C95.9358 19.1855 94.7894 17.0952 94.7894 15.0439C94.7894 12.9926 95.9358 10.9027 98.1948 10.9027C100.452 10.9027 101.599 12.9926 101.599 15.0439C101.599 17.0952 100.452 19.1855 98.1948 19.1855ZM98.1948 9.90771C95.24 9.90771 93.6035 12.2605 93.6035 15.0439C93.6035 17.83 95.24 20.181 98.1948 20.181C101.15 20.181 102.787 17.83 102.787 15.0439C102.787 12.2605 101.15 9.90771 98.1948 9.90771Z",
    fill: "#272724"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6426 16.9838H28.6036L24.8986 6.46484H21.5852V19.8982H23.8246V9.53065H23.8623L27.5886 19.8982H29.5256L33.2511 9.53065H33.2887V19.8982H35.5272V6.46484H32.2556L28.6426 16.9838Z",
    fill: "#272724"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6614 17.8302H63.6237L55.7962 6.46484H54.3655V19.8982H55.6466V8.53287H55.6838L63.5118 19.8982H64.9411V6.46484H63.6614V17.8302Z",
    fill: "#272724"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4918 10.1899L90.008 18.5071H89.9681L87.6009 10.1899H86.2635L83.8927 18.5071H83.8546L81.3708 10.1899H80.1101L83.234 19.8983H84.5314L86.9036 11.7331H86.9404L89.3307 19.8983H90.6286L93.7516 10.1899H92.4918Z",
    fill: "#272724"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5726 14.5548L42.6058 8.77857H42.6616L44.6762 14.5548H40.5726ZM41.3999 6.46436L36.2466 19.8982H38.6732L39.9311 16.3437H45.2958L46.557 19.8982H49.0788L43.9037 6.46436H41.3999Z",
    fill: "#272724"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.187 10.239H121.903V8.8004H121.894L121.329 10.239H121.15L120.585 8.8004H120.577V10.239H120.293V8.51611H120.732L121.246 9.82466L121.752 8.51611H122.187V10.239ZM119.941 8.74605H119.402V10.239H119.117V8.74605H118.578V8.51611H119.941V8.74605Z",
    fill: "#272724"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17892_561023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122.88,
    height: 14.4,
    fill: "white",
    transform: "translate(0 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudiesJamaNatwork123X25);
export default __webpack_public_path__ + "static/media/studies-jamaNatwork-123x25.895c06f369a75d644fa1e63ce0101b9b.svg";
export { ForwardRef as ReactComponent };